/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Component, Input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { requiredIf } from 'app/shared/validation/custom-validators';
import { RegexValidationStrings } from 'app/shared/validation/reg-ex-validation-constants';
import { Subscription } from 'rxjs';

@Component({
	selector: 'social-media-form-list',
	templateUrl: './social-media-form-list.component.html',
	styleUrls: ['./social-media-form-list.component.scss'],
	standalone: false,
})
export class SocialMediaFormListComponent {
	@Input() formArray: FormArray;
	@Input() parentFormGroup: FormGroup;
	@Input() startTabIndex = 1;
	static SocialMediaIncludeChangesSubscription: Subscription;

	static buildSocialMediaList(fb: FormBuilder, socialMediaList: any[]): FormArray {
		if (!socialMediaList) return fb.array([]);
		return fb.array(socialMediaList.map((item) => this.createSocialMediaItem(fb, item)));
	}

	static createSocialMediaItem(fb: FormBuilder, item: any): FormGroup {
		const group = fb.group({
			socialPlatformId: [item.socialPlatformId],
			name: [item.name],
			included: [item.included],
			url: [item.url, [requiredIf(() => item.included), Validators.maxLength(200), Validators.pattern(RegexValidationStrings.WEBSITE_URL)]],
			iconUrl: [item.iconUrl],
		});
		this.updateUrlValidation(group);

		return group;
	}

	private static updateUrlValidation(results) {
		const updateUrlValidators = () => {
			const urlControl = results.get('url');
			const includedValue = results.get('included').value;
			const validators = [Validators.maxLength(200), Validators.pattern(RegexValidationStrings.WEBSITE_URL)];
			if (includedValue) {
				validators.push(Validators.required);
			}
			urlControl.setValidators(validators);
			urlControl.updateValueAndValidity({ emitEvent: false });
		};
		updateUrlValidators();
		this.SocialMediaIncludeChangesSubscription = results.get('included').valueChanges.subscribe(() => {
			updateUrlValidators();
		});
	}

	ngOnDestroy() {
		if (SocialMediaFormListComponent.SocialMediaIncludeChangesSubscription) {
			SocialMediaFormListComponent.SocialMediaIncludeChangesSubscription.unsubscribe();
		}
	}
}
